export default [
    { key: 0, value: "Text" },
    { key: 1, value: "Numeric" },
    { key: 2, value: "Boolean" },
    { key: 3, value: "Combo" },
    { key: 4, value: "Variable" },
    { key: 5, value: "Attach" },
    { key: 6, value: "ItemTag" },
    { key: 7, value: "Draw" },
    { key: 8, value: "Video" },
    { key: 9, value: "Parameter" },
    { key: 10, value: "Time" },
]